/* Deco Gear "Duo" product page: local nav + sticky buy, phone buy bar, Add to cart / Buy now (with
   quantity), variant select, list-price note, photo gallery, delivery line (assets/dg-delivery.js, the
   live site's logic) and the hero turntable (assets/dg-spin.js on three.js r128) with the colour-ribbon +
   logo landing from the approved prototype (proto/mock/duo/index.html). No dependencies; classic script. */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function reduce() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function mountAll() {
    var roots = document.querySelectorAll('[data-dgd]');
    for (var i = 0; i < roots.length; i++) mount(roots[i]);
  }
  ready(mountAll);
  document.addEventListener('shopify:section:load', mountAll); // theme editor re-renders

  function mount(root) {
    if (root.__dgd) return; root.__dgd = true;
    var form = document.getElementById(root.getAttribute('data-form-id'));
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var buyable = root.getAttribute('data-buyable') === 'true';
    var fold = $('.dgd-fold'), card = $('[data-dgd-buy]');
    var errEl = form && form.querySelector('.dgd-error');   // before initQty(): it calls hideError()
    var okNow = buyable, lastDel = null;

    // Nav links: show only those whose section is on the page.
    $$('[data-dgd-link]').forEach(function (a) {
      var id = (a.getAttribute('href') || '').slice(1);
      if (!id || !document.getElementById(id)) a.hidden = true;
    });

    // Buy pill: back to the hero buy box.
    var pill = $('[data-dgd-pill]'), hero = $('[data-dgd-hero]');
    if (pill && hero) pill.addEventListener('click', function (e) {
      e.preventDefault();
      var nav = $('[data-dgd-lnav]'), off = nav && getComputedStyle(nav).position !== 'fixed' ? nav.offsetHeight : 0;
      var y = hero.getBoundingClientRect().top + window.pageYOffset - off;
      window.scrollTo({ top: Math.max(0, y), behavior: reduce() ? 'auto' : 'smooth' });
    });

    // Phone fold: the inline guard after .dgd-fold re-checks the fit when the card's height changes.
    function refit() { if (fold && fold.__dgdFit) fold.__dgdFit(); }
    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg; errEl.hidden = false; refit();
      if (card) {
        var r = card.getBoundingClientRect();
        if (r.top < 0 || r.bottom > (window.innerHeight || document.documentElement.clientHeight)) card.scrollIntoView({ block: 'center', behavior: reduce() ? 'auto' : 'smooth' });
      }
    }
    function hideError() { if (errEl && !errEl.hidden) { errEl.hidden = true; errEl.textContent = ''; refit(); } }

    // Quantity stepper: a real name="quantity" field (posted by Add to cart and Buy now), capped at stock.
    // aria-disabled (not disabled) at the limits so keyboard focus never drops to <body>.
    function initQty() {
      var box = $('[data-dgd-qty]'); if (!box) return null;
      var inp = box.querySelector('[data-dgd-qty-in]'), dec = box.querySelector('[data-dgd-qty-dec]'), inc = box.querySelector('[data-dgd-qty-inc]'), live = box.querySelector('[data-dgd-qty-live]');
      if (!inp || !dec || !inc) return null;
      var max = Math.max(1, +inp.max || 999);
      function val() { var v = parseInt(inp.value, 10); return isNaN(v) ? 1 : v; }
      function set(v, say) {
        v = Math.max(1, Math.min(max, v | 0)); inp.value = v;
        dec.setAttribute('aria-disabled', v <= 1 ? 'true' : 'false'); inc.setAttribute('aria-disabled', v >= max ? 'true' : 'false');
        if (say && live) live.textContent = 'Quantity ' + v;
        hideError();
      }
      dec.addEventListener('click', function () { if (dec.getAttribute('aria-disabled') !== 'true') set(val() - 1, true); });
      inc.addEventListener('click', function () { if (inc.getAttribute('aria-disabled') !== 'true') set(val() + 1, true); });
      inp.addEventListener('change', function () { set(val(), false); });
      // Enter must not submit natively (that would hand the form to the theme's drawer handler).
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); set(val(), false); } });
      set(val(), false);                       // also syncs a back-nav restored value
      return { get: function () { return val(); }, setMax: function (m) { max = Math.max(1, m); inp.max = max; set(val(), false); } };
    }
    var qty = initQty();

    // Add to cart -> the /cart page; Buy now -> checkout. Quantity 1: the product form submitted natively
    // (bypasses the theme's AJAX drawer handler; /cart/add 302s to return_to). Quantity > 1: /cart/add.js,
    // so an over-stock add shows Shopify's own message in the form instead of an error page.
    function nativeGo(kind, b) {
      var h = form.querySelector('input[name="checkout"]');
      if (kind === 'checkout') {
        if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = 'Checkout'; form.appendChild(h); }
      } else if (h) h.remove();
      var rt = form.querySelector('input[name="return_to"]');
      if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; form.appendChild(rt); }
      rt.value = kind === 'checkout' ? '/checkout' : '/cart';
      b.setAttribute('aria-busy', 'true');
      HTMLFormElement.prototype.submit.call(form);
    }
    function ajaxAdd(kind, b) {
      var fd = new FormData(form), drop = [];
      fd.delete('checkout'); fd.delete('return_to');
      fd.forEach(function (v, k) { if (/^properties\[Estimated/.test(k)) drop.push(k); });
      drop.forEach(function (k) { fd.delete(k); });
      b.setAttribute('aria-busy', 'true');
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j || {} }; }); })
        .then(function (res) {
          if (res.ok) { location.assign(kind === 'checkout' ? '/checkout' : '/cart'); return; }
          b.removeAttribute('aria-busy');
          var msg = res.j.description || res.j.message;
          if (msg) showError(String(msg)); else nativeGo(kind, b);
        })
        .catch(function () { b.removeAttribute('aria-busy'); nativeGo(kind, b); });
    }
    function go(kind, b) {
      if (!form || b.disabled) return;
      if (qty && qty.get() > 1 && window.fetch && window.FormData && FormData.prototype.delete) ajaxAdd(kind, b);
      else nativeGo(kind, b);
    }
    $$('[data-dgd-buynow]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); go('checkout', b); });
    });
    $$('.dgd-btn--atc,.dgd-sbtn:not(.dgd-sbtn--now)').forEach(function (b) {
      b.addEventListener('click', function (e) { if (!form || b.disabled) return; e.preventDefault(); go('cart', b); });
    });
    // Back from checkout/cart (bfcache restore): un-dim the buttons and drop the redirect inputs so a later
    // AJAX Add to cart is a plain add.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || !form) return;
      $$('[data-dgd-buynow],.dgd-btn--atc,.dgd-sbtn').forEach(function (b) { b.removeAttribute('aria-busy'); });
      ['checkout', 'return_to'].forEach(function (n) { var i = form.querySelector('input[name="' + n + '"]'); if (i) i.remove(); });
    });

    // Variant select: one pass updates every price surface (hero, local nav, phone bar), both SKU forms,
    // availability, delivery, the quantity cap and the URL (keeps ?view=duo).
    var sel = $('[data-dgd-vsel]');
    function applyVariant(o) {
      var d = o.dataset, ok = d.available === 'true', has = !!d.compare;
      var input = form && form.querySelector('[data-dgd-variant]'); if (input) input.value = o.value;
      $$('[data-dgd-price]').forEach(function (n) { n.textContent = d.price; });
      $$('[data-dgd-was]').forEach(function (n) { n.textContent = d.compare || ''; });
      $$('[data-dgd-deal]').forEach(function (n) { n.hidden = !has; });
      $$('[data-dgd-save-l]').forEach(function (n) { n.textContent = has ? 'Save ' + d.saveAmt + ' (' + d.savePct + '%)' : ''; });
      $$('[data-dgd-save-s]').forEach(function (n) { n.textContent = has ? 'Save ' + d.savePct + '%' : ''; });
      $$('[data-dgd-sku]').forEach(function (n) { n.textContent = d.sku || ''; });  // one node serves desktop "– SKU" and phone "SKU …"
      var vl = $('[data-dgd-vlabel]'); if (vl) vl.textContent = o.textContent;
      $$('.dgd-btn,.dgd-sbtn').forEach(function (b) { if (b.type === 'submit' || b.hasAttribute('data-dgd-buynow')) b.disabled = !ok; });
      var lab = $('.dgd-ctas .dgd-btn--atc [data-sold-out]'); if (lab) lab.textContent = ok ? 'Add to cart' : 'Sold out';
      if (!has) setTip(false);
      okNow = ok; paintDelivery();
      if (qty) qty.setMax(+d.max || 999);
      hideError();
      try { var u = new URL(location.href); u.searchParams.set('variant', o.value); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
    }
    if (sel) {
      sel.addEventListener('change', function () { applyVariant(sel.options[sel.selectedIndex]); });
      var hid = form && form.querySelector('[data-dgd-variant]');
      if (hid && hid.value !== sel.value) applyVariant(sel.options[sel.selectedIndex]);  // form-restore mismatch on back nav
    }

    // Sticky: once the hero buy box scrolls under the nav, the nav shows price + buttons
    // (desktop) and the phone bar (and the phone's local nav) slide in.
    var mini = $('[data-dgd-mini]'), bar = $('[data-dgd-pbar]');
    function setStuck(on) {
      if (root.classList.contains('is-stuck') === on) return;
      root.classList.toggle('is-stuck', on);
      [mini, bar].forEach(function (el) {
        if (!el) return;
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
        Array.prototype.forEach.call(el.querySelectorAll('button'), function (b) { b.tabIndex = on ? 0 : -1; });
      });
    }
    if (card && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        setStuck(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { rootMargin: '-52px 0px 0px 0px' }).observe(card);
    }

    // Rating from Bazaarvoice: read the inline summary it renders (hidden) and show it in the
    // prototype's row (stars, value, count). Count 0 shows nothing; unreadable shows Bazaarvoice's own row.
    var bv = $('[data-dgd-bv]');
    if (bv) {
      var mo = null, giveUp = 0;
      var finish = function () { if (mo) mo.disconnect(); clearTimeout(giveUp); };
      var scan = function () {
        var lab = bv.querySelector('[aria-label*="rating value"]');
        var mv = lab && /([0-9]+(?:\.[0-9]+)?)\s*of\s*5/i.exec(lab.getAttribute('aria-label') || '');
        var mc = /\(([0-9][0-9,]*)\)/.exec(bv.innerText || '');
        if (!mv || !mc) return false;
        var v = parseFloat(mv[1]), n = parseInt(mc[1].replace(/,/g, ''), 10);
        finish();
        if (!(n > 0) || !(v > 0)) { bv.classList.add('is-done'); return true; }
        var full = Math.max(0, Math.min(5, Math.round(v))), stars = '', vs = (Math.round(v * 10) / 10).toFixed(1);
        for (var i = 1; i <= 5; i++) stars += i <= full ? '★' : '<i>★</i>';
        var a = document.createElement('a');
        a.className = 'dgd-rate'; a.href = '#dg-reviews';
        a.setAttribute('aria-label', 'Rated ' + vs + ' out of 5 from ' + n + (n === 1 ? ' review' : ' reviews'));
        a.innerHTML = '<span class="dgd-stars" aria-hidden="true">' + stars + '</span><b aria-hidden="true">' + vs + '</b><span aria-hidden="true"> · ' + n.toLocaleString('en-US') + (n === 1 ? ' review' : ' reviews') + '</span>';
        bv.parentNode.insertBefore(a, bv);
        bv.classList.remove('is-raw'); bv.classList.add('is-done');
        return true;
      };
      if (!scan()) {
        if ('MutationObserver' in window) { mo = new MutationObserver(function () { scan(); }); mo.observe(bv, { childList: true, subtree: true, characterData: true, attributes: true }); }
        // After 10 s show Bazaarvoice's own row (clipped to the slot), but keep watching for 20 s more so a
        // late Bazaarvoice render is still mirrored (slow phones) instead of leaving the raw row.
        giveUp = setTimeout(function () { if (!scan()) { bv.classList.add('is-raw'); setTimeout(function () { if (mo) mo.disconnect(); }, 20000); } }, 10000);
      }
    }

    // Delivery line (no-JS text stays when the script is missing). The sub line carries no leading "·":
    // phones show it on its own grey line; desktop CSS draws the dot.
    function paintDelivery() {
      if (root.getAttribute('data-ships') === 'false') return;
      var main = $('[data-dgd-del]'), sub = $('[data-dgd-sub]'), box = main && main.parentNode, shorts = $$('[data-dgd-del-short]');
      if (!main) return;
      if (!okNow) { main.textContent = 'Currently sold out'; if (sub) sub.textContent = ''; box.classList.add('dgd-del--out'); shorts.forEach(function (n) { n.textContent = 'Sold out'; }); return; }
      box.classList.remove('dgd-del--out');
      if (!lastDel) { main.textContent = 'Free shipping'; if (sub) sub.textContent = 'Typically arrives in 3–5 business days'; shorts.forEach(function (n) { n.textContent = 'Free delivery'; }); return; }
      main.textContent = 'Free delivery ' + lastDel.deliveryShort;
      if (sub) sub.textContent = lastDel.shipsToday ? 'order within ' + lastDel.orderWithin : lastDel.shipLabel;
      shorts.forEach(function (n) { n.textContent = 'Free delivery ' + lastDel.deliveryShort; });
    }
    function fillDelivery() {
      if (root.getAttribute('data-ships') === 'false') return true;
      if (!window.DGDelivery) return false;
      window.DGDelivery.init(function (r) { lastDel = r; paintDelivery(); });   // init even if the first variant is sold out
      return true;
    }
    if (!buyable) paintDelivery();
    if (!fillDelivery()) window.addEventListener('load', fillDelivery);

    // List-price (i) note: tap/click toggles; Esc (focus back to the (i)) and outside taps close.
    var ib = $('.dgd-itip'), tip = ib && document.getElementById(ib.getAttribute('aria-controls'));
    function setTip(on) {
      if (!tip || !ib) return; tip.hidden = !on; ib.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { // keep the bubble on-screen; point the arrow at the (i)
        tip.style.left = '50%'; tip.style.transform = 'translateX(-50%)';
        var r = tip.getBoundingClientRect(), pad = 16, dx = 0;
        if (r.left < pad) dx = pad - r.left; else if (r.right > innerWidth - pad) dx = innerWidth - pad - r.right;
        tip.style.transform = 'translateX(calc(-50% + ' + dx + 'px))';
        var ir = ib.getBoundingClientRect(), tr = tip.getBoundingClientRect();
        tip.style.setProperty('--tip-x', Math.round(ir.left + ir.width / 2 - tr.left) + 'px');
      }
    }
    if (ib && tip) {
      ib.addEventListener('click', function (e) { e.stopPropagation(); setTip(tip.hidden); });
      document.addEventListener('click', function (e) { if (!tip.hidden && !tip.contains(e.target)) setTip(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !tip.hidden) { setTip(false); ib.focus(); } });
    }

    // Photo gallery: native <dialog>; swipe / arrows / thumbs; Esc or close returns focus to the opener.
    var dl = $('[data-dgd-lb]');
    if (dl && dl.showModal) (function () {
      var ev = function (n) { try { window.clarity && window.clarity('event', n); } catch (e) {} };
      var track = dl.querySelector('[data-dgd-lb-track]'), count = dl.querySelector('[data-dgd-lb-count]');
      var thumbs = Array.prototype.slice.call(dl.querySelectorAll('[data-dgd-lb-go]')), dots = Array.prototype.slice.call(dl.querySelectorAll('.dgd-lb__dots li'));
      var prev = dl.querySelector('[data-dgd-lb-prev]'), next = dl.querySelector('[data-dgd-lb-next]');
      var n = track.children.length, cur = 0, opener = null;
      function mark(i) {
        cur = i; count.textContent = (i + 1) + ' of ' + n;
        thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
        dots.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
        prev.disabled = i === 0; next.disabled = i === n - 1;
      }
      function go(i, smooth) { i = Math.max(0, Math.min(n - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !reduce() ? 'smooth' : 'auto' }); mark(i); }
      var raf = 0;
      track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) { mark(i); ev('duo_photo_swipe'); } }); }, { passive: true });
      function open(i, from) { opener = from || null; if (!dl.open) dl.showModal(); go(i, false); dl.querySelector('[data-dgd-lb-close]').focus({ preventScroll: true }); }
      $$('[data-dgd-ph]').forEach(function (b) { b.addEventListener('click', function () { open(+b.getAttribute('data-dgd-ph') || 0, b); }); });
      var strip = $$('.dgd-photos [data-dgd-ph]');
      $$('[data-dgd-ph-more]').forEach(function (b) {
        b.addEventListener('click', function () {
          var k = -1; for (var j = 0; j < strip.length; j++) { if (!strip[j].offsetParent) { k = j; break; } }
          open(k < 0 ? 0 : k, b);
        });
      });
      dl.querySelector('[data-dgd-lb-close]').addEventListener('click', function () { dl.close(); });
      dl.addEventListener('close', function () { if (opener) opener.focus({ preventScroll: true }); });
      prev.addEventListener('click', function () { go(cur - 1, true); });
      next.addEventListener('click', function () { go(cur + 1, true); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k, true); }); });
      dl.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1, true); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1, true); } else if (e.key === 'Home') { e.preventDefault(); go(0, true); } else if (e.key === 'End') { e.preventDefault(); go(n - 1, true); } });
      window.addEventListener('resize', function () { if (dl.open) go(cur, false); });
    })();

    // Turntable. Page B (templates/product.duo.json) also has the desktop hero (sections/dg-hybrid-desk.liquid,
    // [data-dgh]), which owns the 3D at >= 861px: then mount here only at <= 860px, destroy on leaving (one hero
    // WebGL context per breakpoint).
    var turn = $('[data-dgd-turn]');
    if (turn && !reduce() && webgl()) {
      if (document.querySelector('[data-dgh]') && window.matchMedia) gate(root, turn);
      else spin(root, turn);
    }
  }

  function gate(root, turn) {
    var mq = matchMedia('(max-width:860px)'), on = false, tok = 0;
    function apply() {
      if (mq.matches && !on) { on = true; var my = ++tok; spin(root, turn, function () { return on && my === tok; }); }
      else if (!mq.matches && on) {
        on = false; tok++;
        var S = root.__dgdSpin; root.__dgdSpin = null;
        if (S) release(S, turn.querySelector('[data-dgd-gl]'));
        root.classList.remove('is-ready', 'is-landed');
        var rp = root.querySelector('[data-dgd-replay]'); if (rp) rp.hidden = true;
      }
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
  }
  // Destroy, release the GL context and swap in a fresh canvas for a later mount.
  function release(S, gl) {
    try { S.stopScreen(); S.destroy(); } catch (e) {}
    try { var c = gl.getContext('webgl2') || gl.getContext('webgl'), x = c && c.getExtension('WEBGL_lose_context'); if (x) x.loseContext(); } catch (e) {}
    var n = gl.cloneNode(false); if (gl.parentNode) gl.parentNode.replaceChild(n, gl);
  }

  function webgl() {
    try { var c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl'))); }
    catch (e) { return false; }
  }
  function load(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script'); s.src = src; s.async = false;
      s.onload = res; s.onerror = function () { rej(new Error('load ' + src)); };
      document.head.appendChild(s);
    });
  }

  function spin(root, turn, alive) {
    var d = function (k) { return turn.getAttribute('data-' + k); };
    var gl = turn.querySelector('[data-dgd-gl]'), replay = root.querySelector('[data-dgd-replay]');
    var chain = window.THREE ? Promise.resolve() : load(d('three'));
    chain.then(function () { return window.DGSpin ? null : load(d('spin')); }).then(function () {
      return window.DGSpin.mount(gl, {
        mesh: d('mesh'), views: d('views'),
        textures: { front: d('tex-front'), front34r: d('tex-front34r'), front34l: d('tex-front34l'), rear34b: d('tex-rear34b'), rear34a: d('tex-rear34a'), rear: d('tex-rear') },
        onLanded: function () { if (!alive || alive()) root.classList.add('is-landed'); }
      });
    }).then(function (S) {
      if (alive && !alive()) { release(S, gl); return; }
      // Landing screen: vivid flowing colour field (drawn small, scaled up = silky gradients), crisp white logo on top.
      var logo = new Image(); logo.crossOrigin = 'anonymous'; logo.src = d('logo');
      var fld = document.createElement('canvas'); fld.width = 384; fld.height = 108; var fx = fld.getContext('2d');
      var RIB = [[255, 64, 129], [255, 149, 0], [0, 199, 255], [124, 77, 255], [0, 230, 160]];
      function colour(x, w, h, t) {
        fx.fillStyle = '#07081a'; fx.fillRect(0, 0, 384, 108);
        fx.globalCompositeOperation = 'lighter';
        RIB.forEach(function (c, k) {
          var ph = t * .35 + k * 1.3; fx.beginPath();
          for (var i = 0; i <= 48; i++) { var X = i / 48 * 384; var Y = 54 + Math.sin(i / 48 * Math.PI * 2 * (.8 + k * .15) + ph) * 26 + Math.sin(i / 9 + ph * 1.7) * 7; if (i) fx.lineTo(X, Y); else fx.moveTo(X, Y); }
          fx.lineWidth = 18 + 8 * Math.sin(ph * .7);
          var g = fx.createLinearGradient(0, 0, 384, 0); g.addColorStop(0, 'rgba(' + c + ',0)'); g.addColorStop(.5, 'rgba(' + c + ',.85)'); g.addColorStop(1, 'rgba(' + c + ',.15)');
          fx.strokeStyle = g; fx.filter = 'blur(7px)'; fx.stroke();
        });
        fx.filter = 'none'; fx.globalCompositeOperation = 'source-over';
        x.imageSmoothingQuality = 'high'; x.drawImage(fld, 0, 0, w, h);
        var a = Math.min(1, Math.max(0, (t - .35) / .6));
        if (logo.complete && logo.naturalWidth && a > 0) {
          var lw = w * .34, lh = lw * 41.81 / 319.26, s = .96 + .04 * a;
          x.save(); x.globalAlpha = a; x.translate(w / 2, h / 2); x.scale(s, s); x.shadowColor = 'rgba(0,0,0,.35)'; x.shadowBlur = 24; x.drawImage(logo, -lw / 2, -lh / 2, lw, lh); x.restore();
        }
      }
      S.paintScreen(function (x, w, h) { colour(x, w, h, 0); });
      root.classList.add('is-ready');
      var timer = 0;
      function go() {
        if (alive && !alive()) return;
        root.classList.remove('is-landed'); clearTimeout(timer);
        S.stopScreen(); S.paintScreen(function (x, w, h) { colour(x, w, h, 0); });
        S.play({ from: 390, to: 0, dur: 3400 });
        timer = setTimeout(function () { S.screenLoop(function (x, w, h, t) { colour(x, w, h, Math.min(t, 5)); if (t > 5.2) { S.stopScreen(); } }); }, 3400);
      }
      setTimeout(go, 250);
      if (replay) { replay.hidden = false; replay.onclick = go; }
      root.__dgdSpin = S;
    }).catch(function (e) {
      // Poster stays; nothing else depends on the turntable.
      root.classList.remove('is-ready');
      if (window.console) console.warn('[dg-duo] turntable unavailable:', e && e.message);
    });
  }
})();
;(function(){function t(){var f=document.getElementById('merchantwidgetiframe');if(f&&!f.title)f.title='Google customer reviews badge'}setTimeout(t,3000);setTimeout(t,8000)})();
;/* Microsoft Clarity: tag sessions on the new template and record key actions (queue-safe if Clarity loads later) */
(function(){
  /* Always call window.clarity at call time: Clarity's loader replaces the queue stub with the real function,
     so a reference captured here would keep feeding a dead queue after Clarity loads. */
  window.clarity=window.clarity||function(){(window.clarity.q=window.clarity.q||[]).push(arguments)};
  var c=function(){ return window.clarity.apply(window,arguments); };
  var root=document.querySelector('[data-dgd]'); if(!root) return;
  var h=(location.pathname.split('/products/')[1]||'').split(/[/?#]/)[0];
  try{ c('set','pdp_template','duo'); c('set','pdp_handle',h); c('set','duo_version','b2'); c('event','duo_view'); }catch(e){}
  function ev(n){ try{ c('event',n); c('upgrade',n); }catch(e){} }
  document.addEventListener('click',function(e){
    var t=e.target.closest && e.target.closest('button,a'); if(!t) return;
    if(t.closest('.dgd-btn--atc,.dgd-sbtn:not(.dgd-sbtn--now)')) ev('duo_add_to_cart');
    else if(t.closest('.dgd-btn--buy,.dgd-sbtn--now')) ev('duo_buy_now');
    else if(t.closest('.dgd-replay')) ev('duo_replay');
    else if(t.closest('.dgd-itip')){ if(t.getAttribute('aria-expanded')!=='true') ev('duo_listprice_info'); }
    else if(t.closest('[data-dgd-ph],[data-dgd-ph-more]')) ev('duo_photos_open');
    else if(t.closest('[data-dgd-qty-dec],[data-dgd-qty-inc]')) ev('duo_qty');
    else if(/#dg-(bv-)?reviews$/.test(t.getAttribute('href')||'')) ev('duo_reviews_link');
    else if(t.closest('#dg-faq')) ev('duo_faq');
    else if(t.closest('#dg-compare')) ev('duo_compare');
  },true);
  document.addEventListener('change',function(e){ var t=e.target; if(!t||!t.matches) return; if(t.matches('[data-dgd-vsel]')) ev('duo_variant'); else if(t.matches('[data-dgd-qty-in]')) ev('duo_qty'); },true);
  var seen={}; if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(es){es.forEach(function(x){if(x.isIntersecting&&!seen[x.target.id]){seen[x.target.id]=1;try{c('event','duo_seen_'+x.target.id.replace(/^dg-/,''))}catch(e){}}})},{threshold:0,rootMargin:'0px 0px -40% 0px'});
    ['dg-highlights','dg-design','dg-viewer','dg-display','dg-versatility','dg-connect','dg-performance','dg-desk','dg-accessories','dg-compare','dg-reviews','dg-bv-reviews','dg-why','dg-faq'].forEach(function(id){var el=document.getElementById(id);if(el)io.observe(el)}); }
})();
;/* Keep the "Estimated Delivery Date Plus" app's line-item estimate off items added from this page:
   it injects hidden properties[Estimated between] inputs (a different date range than our delivery line). */
(function(){
  var root=document.querySelector('[data-dgd]'); if(!root) return;
  function strip(){ root.querySelectorAll('input[name^="properties[Estimated"]').forEach(function(i){ i.remove(); }); }
  strip();
  try{ new MutationObserver(strip).observe(root,{childList:true,subtree:true}); }catch(e){}
  document.addEventListener('submit',strip,true);
  document.addEventListener('click',function(e){ if(e.target.closest && e.target.closest('.dgd-btn,.dgd-sbtn,[form]')) strip(); },true);
})();

/* "Write a review" on page B: open Bazaarvoice's review form directly (the same pop-up the old page uses)
   instead of only jumping to the reviews list. Falls back to the normal link if Bazaarvoice isn't loaded. */
(function () {
  function bvId() { var n = document.querySelector('[data-bv-product-id]'); return n && n.getAttribute('data-bv-product-id'); }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a.dgh-war, a.rev-tile');
    if (!a || !/write a review/i.test(a.textContent || '')) return;
    var id = bvId();
    if (!id || !window.$BV || typeof window.$BV.ui !== 'function') return;
    e.preventDefault();
    try { window.$BV.ui('rr', 'submit_review', { productId: id }); } catch (err) { location.hash = 'dg-bv-reviews'; }
    try { var c = window.clarity; if (typeof c === 'function') c('event', 'duo_write_review'); } catch (err) {}
  }, true);
})();
